import { DeliverablesTableConfig} from "./deliverables-tracker.objects";
import { DeliverablesTable } from "./deliverables-tracker.table";

export class DeliverablesTrackerPage {
    deliverablesTableConfig: DeliverablesTableConfig;
    deliverablesTable: DeliverablesTable;

    constructor() {
        $(() => {
            this.deliverablesTableConfig = {
                getDeliverablesRoute: "/secure/deliverables-tracker/deliverables-tracker?handler=Deliverables",
                tableContainerId: "deliverables-content",
                loadingContainerId: "loading-content-container",
                loadedContentId: "loaded-content",
                isEditable: false,
                tableVarName: "deliverablesTable",
                isAdmin: false,
                editModalId: "",
                postParentRoute: "",
                postChildRoute: "",
                getCommentsChildRoute: "/secure/deliverables-tracker/deliverables-tracker?handler=GetComments",
                postCommentChildRoute: "",
                commentModalId: "",
                attachmentModalId: "",
                getAttachmentsRoute: "/secure/deliverables-tracker/deliverables-tracker?handler=GetAttachments",
                addAttachmentsRoute: "",
                removeAttachmentsRoute: "",
                addModalId: "",
                additionalInfoModalId: "",
                viewDeliverableModalId: "view-deliverable-modal",
                showUserGuide: false,
                userGuideLink: ""
            }

            this.deliverablesTable = new DeliverablesTable(this.deliverablesTableConfig);
        });
    }

    closeAllModals() {
        $(".modal").modal('hide');
    }
}
